import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PremiumRideService {

  constructor(
    private http: HttpClient
  ) { }

  getPremiumLines(): Observable<any> {
    return this.http
      .get<any>(environment.apiUrl + '/v2/routes/premium-lines');
  }

  findRide(item): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + '/v2/routes/find-rides', JSON.stringify(item));
  }

  bookRide(item): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + '/v2/routes/book-ride', JSON.stringify(item));
  }

  cancelRide(item): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + '/v2/routes/cancel-ride', JSON.stringify(item));
  }

  trackRide(item): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + '/v2/routes/track-ride', JSON.stringify(item));
  }

  getPremiumBusActivity(item): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + '/v2/routes/bus-trip-activity', JSON.stringify(item));
  }

  waitPremiumRide(item): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + '/v2/routes/wait-ride', JSON.stringify(item));
  }

  findMultipleRides(item): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + '/v2/routes/find-rides-multiple', JSON.stringify(item));
  }

  bookMultipleRide(item): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + '/v2/routes/book-ride-multiple', JSON.stringify(item));
  }
}
